import React from 'react'
import "../pages/styles/commonsec.css"

const Dashboard = () => {
  return (
    <div className='dash text-center'>(Not implimented since no data to be retrieved)
    </div>
    
  )
}

export default Dashboard
